import { ReactNode } from 'react'
import { AuthenticationStatus } from '../types'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { userStorage } from '../../../services/utils/local-storage'

type ProtectedRouteProps = {
  children?: ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { pathname, search } = useLocation()
  const loginState = userStorage.get()
    ? AuthenticationStatus.LoggedIn
    : AuthenticationStatus.LoggedOut

  if (loginState === AuthenticationStatus.LoggedOut) {
    const redirect = `${pathname}${search}`
    return <Navigate to={`/login?redirect=${redirect}`} replace />
  }

  return children ? children : <Outlet />
}
